export enum PwaSyncType {
  Offline = 1,
  Unsync = 2,
  Sync = 3
}